import { render, staticRenderFns } from "./FooterDialogProduct.vue?vue&type=template&id=fd3c96d0&"
import script from "./FooterDialogProduct.vue?vue&type=script&lang=js&"
export * from "./FooterDialogProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3c96d0')) {
      api.createRecord('fd3c96d0', component.options)
    } else {
      api.reload('fd3c96d0', component.options)
    }
    module.hot.accept("./FooterDialogProduct.vue?vue&type=template&id=fd3c96d0&", function () {
      api.rerender('fd3c96d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/FooterDialogProduct.vue"
export default component.exports